import { marked } from "marked";
import React, { useEffect, useState } from "react";
import { parse } from "semver";
import { oblacDrivesBrandId, makeCdnUrl } from "motion-master-client";

const FirmwareChangelog = ({ version, isActive }) => {
  const [changelog, setChangelog] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const parseVersionToFileName = () => {
    if (!version) return ""; // no version

    const isSubpatch = /\+/g.test(version);
    if (isSubpatch) {
      return `${encodeURIComponent(version)}.md`;
    }

    const { major, minor } = parse(version);
    return `v${major}.${minor}.md`;
  };

  const changeLogUrl = makeCdnUrl(
    `/brands/${oblacDrivesBrandId}/changelogs/${parseVersionToFileName()}`
  );

  useEffect(() => {
    setIsFetching(true);
    setFetchError(null);
    setChangelog(null);

    fetch(changeLogUrl)
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.text();
      })
      .then((md) => {
        setChangelog(marked.parse(md ?? ""));
      })
      .catch((err) => {
        console.error(err);
        setFetchError(err);
      })
      .finally(() => setIsFetching(false));
  }, [changeLogUrl]);

  useEffect(() => {
    if (!changelog || !isActive) return;

    const container = document.querySelector(".changelog");
    if (!container) return;

    const versionHeadings = container.querySelectorAll("h2");
    const versionHeading = Array.from(versionHeadings).find((h) =>
      h.innerText.startsWith(version)
    );

    versionHeading?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [changelog, version, isActive]);

  return (
    <div>
      {isFetching && <strong role="status">Loading...</strong>}
      {fetchError && <strong>{fetchError.message}</strong>}
      {changelog && (
        <div className="overflow-auto" style={{ maxHeight: "calc(100vh - 468px)" }}>
          <div
            className="changelog"
            dangerouslySetInnerHTML={{ __html: changelog }}
          />
        </div>
      )}
      {!isFetching && !changelog && !fetchError && (
        <p>No changelog available.</p>
      )}
    </div>
  );
};

export default FirmwareChangelog;
